import { call, put, takeEvery } from "redux-saga/effects";

import {
  CREATE_PARTS_QUANTITIES,
  DELETE_BINDING_NOTES,
  GET_OFFER_FILTERED_PARTS,
  GET_ORDER_FILTERED_PARTS,
  GET_PARTS_PREDICTS_AND_REAL,
  GET_PART_CONFIG_OPTIONS,
  GET_SIMILAR_PARTS_DETAIL,
  GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS,
  CREATE_PART_STEP_ANALYSIS,
  GET_TECHNOLOGIES_DASHBOARD,
  UPDATE_BINDING_NOTES,
  UPDATE_PARTS,
  UPDATE_PARTS_STATUS,
  ANALYZE_STEP_ONSHAPE,
  ANALYZE_STEP_OPENCASCADE,
  DELETE_PART_STEP_ANALYSIS,
  UPLOAD_AND_CONVERT_TO_STEP,
} from "./actionTypes";

import {
  createPartsQuantitiesFail,
  createPartsQuantitiesSuccess,
  deleteBindingNotesFail,
  deleteBindingNotesSuccess,
  getOfferFiltredPartsFail,
  getOfferFiltredPartsSuccess,
  getOrderFiltredPartsFail,
  getOrderFiltredPartsSuccess,
  getPartsStepAnalysisByPartsIdsFail,
  getPartsStepAnalysisByPartsIdsSuccess,
  createPartStepAnalysisFail,
  createPartStepAnalysisSuccess,
  getPartConfigOptionsFail,
  getPartConfigOptionsSuccess,
  getPartsPredictsAndRealFail,
  getPartsPredictsAndRealSuccess,
  getSimilarPartsDetailFail,
  getSimilarPartsDetailSuccess,
  getTechnologiesDashboardFail,
  getTechnologiesDashboardSuccess,
  updateBindingNotesFail,
  updateBindingNotesSuccess,
  updatePartsFail,
  updatePartsStatusFail,
  updatePartsStatusSuccess,
  updatePartsSuccess,
  analyzeStepOnShapeFail,
  analyzeStepOnShapeSuccess,
  analyzeStepOpenCascadeFail,
  analyzeStepOpenCascadeSuccess,
  deletePartStepAnalysisFail,
  deletePartStepAnalysisSuccess,
  uploadAndConvertToStepFail,
  uploadAndConvertToStepSuccess,
} from "./actions";

import {
  CREATE_PARTS_QUANTITIES_ENDPOINT,
  DELETE_BINDING_NOTES_ENDPOINT,
  GET_OFFER_FILTERED_PARTS_ENDPOINT,
  GET_ORDER_FILTERED_PARTS_ENDPOINT,
  GET_PARTS_PREDICTS_AND_REAL_ENDPOINT,
  GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_ENDPOINT,
  CREATE_PART_STEP_ANALYSIS_ENDPOINT,
  GET_PART_CONFIG_OPTIONS_ENDPOINT,
  GET_SIMILAR_PARTS_DETAIL_ENDPOINT,
  GET_TECHNOLOGIES_DASHBOARD_ENDPOINT,
  UPDATE_BINDING_NOTES_ENDPOINT,
  UPDATE_PARTS_ENDPOINT,
  UPDATE_PART_STATUS_ENDPOINT,
  ANALYZE_STEP_ONSHAPE_ENDPOINT,
  ANALYZE_STEP_OPENCASCADE_ENDPOINT,
  DELETE_PART_STEP_ANALYSIS_ENDPOINT,
  UPLOAD_AND_CONVERT_TO_STEP_ENDPOINT,
} from "../../constants/backendRoutes";

import { updateDashboardCountryList } from "store/actions";
import { get, post, postForm2 } from '../../helpers/api_helper'
import { getUserValuesFromLocalStorage } from 'common/Utils/LocalStorageUtilities'

import { getFileNameNoExtension, urlToFile } from "common/Utils/fileUtils";
import { UNIT, getPartMeasures } from "common/Utils/processNewFileUtils/measureUtils";

const decompressBase64 = async (base64) => {
  const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0))
  const blob = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))
  return new Response(blob).text()
}

const decompressBlob = async (blob) => {
  const decompressed = blob.stream().pipeThrough(new DecompressionStream('gzip'))
  return new Response(decompressed).text()
}

const blobToBase64 = (blob) => new Promise(resolve => {
  const reader = new FileReader()
  reader.onloadend = () => resolve(/** @type {string} */ (reader.result).split(',')[1])
  reader.readAsDataURL(blob)
})

function* getPartsPredictsAndReal() {
  try {
    const url = `${GET_PARTS_PREDICTS_AND_REAL_ENDPOINT}`;
    const response = yield call(get, url);
    yield put(getPartsPredictsAndRealSuccess(response));
  } catch (error) {
    yield put(getPartsPredictsAndRealFail(error));
  }
}

function* getPartsStepAnalysisByPartsIds({ payload: { partId } }) {
  try {
    const url = GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_ENDPOINT;
    const input = { data: { partsIds: [partId] } };
    const response = yield call(post, url, input);
    const stepAnalyses = []
    for (const item of response.stepAnalyses) {
      const stepAnalysisJsonString = yield call(decompressBase64, item.stepAnalysisBase64)
      const stepAnalysis = JSON.parse(stepAnalysisJsonString)
      stepAnalyses.push(stepAnalysis)
    }
    yield put(getPartsStepAnalysisByPartsIdsSuccess({ stepAnalyses }, { partId }));
  } catch (error) {
    yield put(getPartsStepAnalysisByPartsIdsFail(error, { partId }));
  }
}

function* createPartStepAnalysis({ payload: { partId, stepAnalysisBase64 } }) {
  try {
    const url = CREATE_PART_STEP_ANALYSIS_ENDPOINT;
    const data = {
      data: {
        partId: partId,
		stepAnalysisBase64: stepAnalysisBase64,
      },
    };
    const response = yield call(post, url, data);
    yield put(createPartStepAnalysisSuccess(response, { partId }));
  } catch (error) {
    yield put(createPartStepAnalysisFail(error, { partId }));
  }
}

function* updatePartsStatus({
  payload: {
    partIds,
    statusId,
    suppliers,
    editingWithinBindingNoteModal,
    newPartsStatus,
  },
}) {
  try {
    const url = `${UPDATE_PART_STATUS_ENDPOINT}`;
    const data = {
      data: {
        partIds,
        statusId,
        suppliers,
        newPartsStatus,
      },
    };
    const response = yield call(post, url, data);
    yield put(
      updatePartsStatusSuccess(response, editingWithinBindingNoteModal)
    );
  } catch (error) {
    yield put(updatePartsStatusFail(error, editingWithinBindingNoteModal));
  }
}

function* createPartsQuantities({ payload: { partIds, quantities } }) {
  try {
    const url = CREATE_PARTS_QUANTITIES_ENDPOINT;
    const data = {
      data: {
        partIds,
        quantities,
      },
    };
    const response = yield call(post, url, data);
    yield put(createPartsQuantitiesSuccess(response));
  } catch (error) {
    yield put(createPartsQuantitiesFail(error));
  }
}

function* getPartConfigOptions({ payload }) {
  const url = GET_PART_CONFIG_OPTIONS_ENDPOINT;

  try {
    const response = yield call(get, url, payload);
    yield put(getPartConfigOptionsSuccess(response));
  } catch (error) {
    yield put(getPartConfigOptionsFail(error));
  }
}

function* updateParts({ payload, context }) {
  const url = UPDATE_PARTS_ENDPOINT;
  try {
    const response = yield call(post, url, { data: payload });
    yield put(updatePartsSuccess(response, context));
  } catch (error) {
    yield put(updatePartsFail(error, context));
  }
}

function* getOfferFiltredParts({ payload: { input, signal } }) {
  try {
    const url = `${GET_OFFER_FILTERED_PARTS_ENDPOINT}`;
    const data = { data: input };
    const response = yield call(post, url, data, { signal });
    yield put(getOfferFiltredPartsSuccess(response));
  } catch (error) {
    yield put(getOfferFiltredPartsFail(error));
  }
}

function* getOrderFiltredParts({ payload: { input, signal } }) {
  try {
    const url = `${GET_ORDER_FILTERED_PARTS_ENDPOINT}`;
    const data = { data: input };
    const response = yield call(post, url, data, { signal });
    yield put(getOrderFiltredPartsSuccess(response));
  } catch (error) {
    yield put(getOrderFiltredPartsFail(error));
  }
}

function* getSimilarPartsDetail({ payload: { partIds } }) {
  try {
    const url = `${GET_SIMILAR_PARTS_DETAIL_ENDPOINT}`;
    const data = { data: partIds };
    const response = yield call(post, url, data);
    yield put(getSimilarPartsDetailSuccess(response));
  } catch (error) {
    yield put(getSimilarPartsDetailFail(error));
  }
}

function* updateBindingNotes({ payload }) {
  try {
    const url = UPDATE_BINDING_NOTES_ENDPOINT;
    const response = yield call(post, url, { data: payload });
    yield put(updateBindingNotesSuccess(response));
  } catch (error) {
    yield put(updateBindingNotesFail(error));
  }
}

function* deleteBindingNotes({ payload }) {
  try {
    const url = DELETE_BINDING_NOTES_ENDPOINT;
    const response = yield call(post, url, { data: payload });
    yield put(deleteBindingNotesSuccess(response));
  } catch (error) {
    yield put(deleteBindingNotesFail(error));
  }
}

function* getTechnologiesDashboard({ payload: { data } }) {
  try {
    const url = GET_TECHNOLOGIES_DASHBOARD_ENDPOINT;
    const response = yield call(post, url, { data });
    yield put(updateDashboardCountryList(response.countryList));
    yield put(getTechnologiesDashboardSuccess(response));
  } catch (error) {
    yield put(getTechnologiesDashboardFail(error));
  }
}

function* deletePartStepAnalysis({ payload: { partId } }) {
  try {
    const url = DELETE_PART_STEP_ANALYSIS_ENDPOINT
    const data = { data: { partId } }
    const response = yield call(post, url, data)
    yield put(deletePartStepAnalysisSuccess(response, { partId }))
  } catch (error) {
    yield put(deletePartStepAnalysisFail(error, { partId }))
  }
}

/** helper for uploadAndConvertToStep */
const callUploadAndConvertToStep = async ({ partId, otherFile }) => {
  const { id: userId, token } = getUserValuesFromLocalStorage()
  const formData = new FormData()
  formData.append('file', otherFile, otherFile.name)
  formData.append('data', JSON.stringify({ partId, userId }))
  const response = await fetch(UPLOAD_AND_CONVERT_TO_STEP_ENDPOINT, {
    method: 'POST',
    body: formData,
    headers: { Authorization: token },
  })
  if (!response.ok) throw await response.text()
  const resJson = await response.json()
  const stepFile = await urlToFile(resJson.stepUrl, `${getFileNameNoExtension(otherFile.name)}.step`)
  return { stepFile, onShapeIds: { did: resJson.did, wid: resJson.wid, tid: resJson.tid, eid: resJson.eid } }
}

function* uploadAndConvertToStep({ payload, metadata }) {
  try {
    const result = yield call(callUploadAndConvertToStep, payload)
    yield put(uploadAndConvertToStepSuccess(result, metadata))
  } catch (error) {
    yield put(uploadAndConvertToStepFail(error, metadata))
  }
}

const callAnalyzeStep = async ({ stepFile, userId }) => {
  const { token } = getUserValuesFromLocalStorage()
  const formData = new FormData()
  formData.append('data', JSON.stringify({ userId }))
  formData.append('stepFile', stepFile, stepFile.name)
  const response = await fetch(`${ANALYZE_STEP_OPENCASCADE_ENDPOINT}?generate_stl=true`, {
    method: 'POST',
    body: formData,
    headers: { Authorization: token },
  })
  if (!response.ok) throw await response.text()
  return response.formData()
}

function* analyzeStepOpenCascade({ payload, metadata }) {
  try {
    const { id: userId } = getUserValuesFromLocalStorage()
    const responseFormData = yield call(callAnalyzeStep, { stepFile: payload.stepFile, userId })

    const gzipBlob = responseFormData.get('data')
    const stlBlob = responseFormData.get('stl')

    const stepAnalysisJsonString = yield call(decompressBlob, gzipBlob)
    const stepAnalysis = JSON.parse(stepAnalysisJsonString)
    const stepAnalysisBase64 = yield call(blobToBase64, gzipBlob)
    const stlFile = new File([stlBlob], `${getFileNameNoExtension(payload.stepFile.name)}.stl`, { type: 'model/stl' })

    yield put(analyzeStepOpenCascadeSuccess({ stepAnalysis, stepAnalysisBase64, stlFile }, metadata))
  } catch (error) {
    yield put(analyzeStepOpenCascadeFail(error, metadata))
  }
}

/** helper for analyzeStepOnShape */
const callAnalyzeStepOnShape = async ({ onShapeIds, partId, filename }) => {
  const { id: userId, token } = getUserValuesFromLocalStorage()
  const response = await fetch(ANALYZE_STEP_ONSHAPE_ENDPOINT, {
    method: 'POST',
    body: JSON.stringify({ data: { onShapeIds, userId, partId, filename } }),
    headers: { Authorization: token, 'Content-Type': 'application/json' },
  })
  if (!response.ok) throw await response.text()
  const onShapeData = await response.json()
  const convertedMeasures = getPartMeasures({
    size: { value: onShapeData.boundingBox, unit: UNIT.millimeters },
    area: { value: onShapeData.surface, unit: UNIT.centimeters },
    volume: { value: onShapeData.volume, unit: UNIT.centimeters },
  })
  const cadData = {
    size_mm: convertedMeasures.size_mm,
    area_cm2: convertedMeasures.area_cm2,
    volume_cm3: convertedMeasures.volume_cm3,
    boundaryBoxVolume_cm3: convertedMeasures.boundaryBoxVolume_cm3,
    chipVolume_cm3: convertedMeasures.chipVolume_cm3,
    faces: onShapeData.faces,
  }
  const stlFile = await urlToFile(onShapeData.stlUrl, `${getFileNameNoExtension(filename)}.stl`)
  return { cadData, stlFile }
}

function* analyzeStepOnShape({ payload, metadata }) {
  try {
    const result = yield call(callAnalyzeStepOnShape, payload)
    yield put(analyzeStepOnShapeSuccess(result, metadata))
  } catch (error) {
    yield put(analyzeStepOnShapeFail(error, metadata))
  }
}

function* PartsSaga() {
  yield takeEvery(UPDATE_PARTS_STATUS, updatePartsStatus);
  yield takeEvery(CREATE_PARTS_QUANTITIES, createPartsQuantities);
  yield takeEvery(GET_PART_CONFIG_OPTIONS, getPartConfigOptions);
  yield takeEvery(UPDATE_PARTS, updateParts);
  yield takeEvery(GET_OFFER_FILTERED_PARTS, getOfferFiltredParts);
  yield takeEvery(GET_ORDER_FILTERED_PARTS, getOrderFiltredParts);
  yield takeEvery(GET_SIMILAR_PARTS_DETAIL, getSimilarPartsDetail);
  yield takeEvery(UPDATE_BINDING_NOTES, updateBindingNotes);
  yield takeEvery(DELETE_BINDING_NOTES, deleteBindingNotes);
  yield takeEvery(GET_TECHNOLOGIES_DASHBOARD, getTechnologiesDashboard);
  yield takeEvery(GET_PARTS_PREDICTS_AND_REAL, getPartsPredictsAndReal);
  yield takeEvery(GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS, getPartsStepAnalysisByPartsIds);
  yield takeEvery(CREATE_PART_STEP_ANALYSIS, createPartStepAnalysis);
  yield takeEvery(ANALYZE_STEP_ONSHAPE, analyzeStepOnShape);
  yield takeEvery(ANALYZE_STEP_OPENCASCADE, analyzeStepOpenCascade);
  yield takeEvery(DELETE_PART_STEP_ANALYSIS, deletePartStepAnalysis);
  yield takeEvery(UPLOAD_AND_CONVERT_TO_STEP, uploadAndConvertToStep);
}

export default PartsSaga;
